import React from "react";

import { Card, CardBody } from "reactstrap";

const Notifications = ({ selected }) =>
  selected === "notifications" && (
    <Card>
      <CardBody>
        <h3>Notifications</h3>

        <p>TBD</p>
      </CardBody>
    </Card>
  );

export default Notifications;
